import React from "react";
import { Button, Spin, Row, Col } from "antd";
import { DownloadOutlined, ExportOutlined } from "@ant-design/icons";
import {
  canOpenInOnlineSpreadsheet,
  getDocumentIcon,
  getExcelOnlineViewerUrl,
  getGoogleViewerUrl,
  getKindTheme,
} from "../chat/documentUtils";
import Flex from "components/shared-components/Flex";

const FileAttachmentCard = ({
  meta,
  url,
  onDownload,
  onDownloadFile,
  isDownloading = false,
}) => {
  const theme = getKindTheme(meta?.kind);
  const icon = getDocumentIcon(meta?.kind, { fontSize: "1.6rem", color: theme.color });

  const openLabel = meta?.kind === "pdf"
    ? "Open PDF"
    : meta?.kind === "image"
      ? "Open Image"
      : `Open ${meta?.typeName || "File"}`;
  const buttonCount = 1
    + (url && (meta?.kind === "pdf" || meta?.kind === "image") ? 1 : 0)
    + (url && canOpenInOnlineSpreadsheet(meta?.kind) ? 2 : 0);
  const colSpan = buttonCount === 1 ? 24 : buttonCount === 2 ? 12 : 8;

  return (
    <Flex
      flexDirection="column"
      style={{
        minWidth: 300,
        maxWidth: 360,
      }}
    >
      <Flex
        alignItems="start"
        gap={12}
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          className="flex-shrink-0"
          style={{
            width: 48,
            height: 48,
            borderRadius: 10,
            background: theme.bg,
          }}
        >
          {icon}
        </Flex>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div
            className="fw-semibold text-dark"
            style={{
              fontSize: 15,
              lineHeight: 1.3,
            }}
          >
            {meta?.typeName}
          </div>
          <div
            className="text-muted mt-1 mb-2"
            style={{
              fontSize: 12,
            }}
          >
            {meta?.subtitle}
          </div>
        </div>
      </Flex >
      <Row
        gutter={[8, 8]}
        align="middle"
        className="w-100 mt-2"
      >
        <Col span={colSpan}>
          {url ? (
            <Button
              type="primary"
              size="small"
              icon={isDownloading ? <Spin size="small" /> : <DownloadOutlined style={{ lineHeight: 1.9 }} />}
              onClick={onDownloadFile}
              disabled={isDownloading || !onDownloadFile}
              className="w-100 fw-medium"
            >
              Download
            </Button>
          ) : (
            <Button
              type="primary"
              size="small"
              icon={isDownloading ? <Spin size="small" /> : <DownloadOutlined style={{ lineHeight: 1.9 }} />}
              onClick={onDownload}
              disabled={isDownloading}
              className="w-100 fw-medium"
            >
              Download
            </Button>
          )}
        </Col>

        {url && (meta?.kind === "pdf" || meta?.kind === "image") && (
          <Col span={colSpan}>
            <Button
              size="small"
              icon={<ExportOutlined style={{ lineHeight: 1.9 }} />}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-100 fw-medium"
              style={{ borderRadius: 8 }}
            >
              {openLabel}
            </Button>
          </Col>
        )}

        {url && canOpenInOnlineSpreadsheet(meta?.kind) && (
          <>
            <Col span={colSpan}>
              <Button
                size="small"
                href={getExcelOnlineViewerUrl(url)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-100"
              >
                Excel Online
              </Button>
            </Col>
            <Col span={colSpan}>
              <Button
                size="small"
                href={getGoogleViewerUrl(url)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-100"
              >
                Google Sheet
              </Button>
            </Col>
          </>
        )}
      </Row>
    </Flex>
  );
};

export default FileAttachmentCard;
